module.exports = __webpack_public_path__ + "static/media/tasks-icon.644bb386.png";